import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=50ad9f5b&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=50ad9f5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ad9f5b",
  null
  
)

export default component.exports